var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_vm._t("default",null,{"toggle":_vm.toggleModal})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }